<div class="displayFlex inicio-inproeco">
  <div class="chart-inicio-inproeco">
    <h2 [routerLink]="['/inproeco/estado/pendientes']">{{ title }}</h2>
    <div class="container">
      <canvas class="canvas" height="530" #doughnutCanvas ></canvas>
      <div class="displayFlex labels">
        <div class="displayFlexColumn">
          <img src="../../../../assets/caducado.svg" alt="" [routerLink]="['/inproeco/estado/documentacion-caducada']"/>
         Ver Documentos <p> Caducados</p>
        </div>
        <!-- <div class="displayFlexColumn">
          <img src="../../../../assets/validado.svg" alt="" />
          Validado
        </div> -->
        <div class="displayFlexColumn">
          <img src="../../../../assets/proximo-a-caducar.svg" alt="" [routerLink]="['/inproeco/estado/documentacion-proxima']" />
          Ver Documentos
          <p>Próximos a caducar</p>
        </div>
      </div>
    </div>
  </div>
  <div class="texto">
    <img src="../../../../assets/selected.svg" alt=""  [routerLink]="['/inproeco/estado/pendientes']" style="cursor: pointer;" />
    <h3>
      Tiene
      <span>{{docPendientes}}</span>
      documentos
      <p>Pendientes de validar</p>
    </h3>
  </div>
</div>
